export default class MessageCenterService {
  constructor($http) {
    this.$http = $http;
  }

  get_data() {
    return this.$http.get('/admin/marketplace/message_center/get_data');
  }
}

MessageCenterService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/message-center.service.js